/**
 * Program Schemas
 */

import { z } from 'zod';

export const programTypeSchema = z.enum([
  'corporate',
  'university',
  'government',
  'ngo',
  'staffing',
]);

export const programStatusSchema = z.enum(['draft', 'active', 'paused', 'completed', 'archived']);

export const createProgramSchema = z.object({
  name: z.string().min(1).max(100),
  description: z.string().max(1000).optional(),
  type: programTypeSchema,
  maxParticipants: z.number().int().positive().optional(),
  startDate: z.coerce.date().optional(),
  endDate: z.coerce.date().optional(),
  settings: z
    .object({
      autoApprove: z.boolean().default(false),
      requireApproval: z.boolean().default(true),
      allowSelfEnrollment: z.boolean().default(false),
    })
    .optional(),
});

export type CreateProgramInput = z.infer<typeof createProgramSchema>;

export const updateProgramSchema = createProgramSchema.partial();

export type UpdateProgramInput = z.infer<typeof updateProgramSchema>;
